import React from 'react';
import {getAppName, getLogoFileName, getWhiteLabelName, whiteLabelNameIs} from "../utils/whitelabel";
import {cn} from "../utils/style";
import logoImage from "../assets/images/logo.png";
import tabeebLogoImage from "../assets/images/tabeeb-logo.png";
import toothpickLogoImage from "../assets/images/toothpick-logo.png";
import paygexLogoImage from "../assets/images/paygex-logo.png";

function Logo({center}) {
    const logoMap = {
        'PAYD': logoImage,
        'TABEEB': tabeebLogoImage,
        'TOOTHPICK': toothpickLogoImage,
        'PAYGEX': paygexLogoImage
    };
    
    const currentLogoSrc = logoMap[getWhiteLabelName()];
    return (
        <img
            className={cn("w-auto",
                {
                    'mx-auto': center || false
                },
                {'h-10': whiteLabelNameIs('TOOTHPICK')},
                {'h-10': whiteLabelNameIs('PAYGEX')},
                {'h-7': whiteLabelNameIs('TABEEB')},
                {'h-24': whiteLabelNameIs('PAYD')},
            )}
            src={currentLogoSrc}
            alt={getAppName()}
        />
    );
}

export default Logo;